module.exports = __webpack_public_path__ + "static/media/vineyard-min.002e00b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/vineyard-min.jpg
// module id = 46
// module chunks = 0